export const authorizedPdfList = [
  {
    id: 'technician',
    name: 'Technician',
    type: 'string',
    disabled: true,
  },
  {
    id: 'dateOfCalibration',
    name: 'Date of Calibration Check',
    type: 'date',
    disabled: true,
  },
  {
    id: 'validity',
    name: 'Validity',
    type: 'checkbox',
  },
  {
    id: 'gab-0',
    name: 'gab',
    type: 'gab',
  },
  {
    id: 'space-0',
    name: 'space',
    type: 'space',
  },
  {
    id: 'sn',
    name: 'Measuring Cell SerNo',
    type: 'number',
    disabled: true,
  },
  {
    id: 'gab-service-station',
    name: 'gab',
    type: 'gab',
  },
  {
    id: 'computerSn',
    name: 'Computer Box SerNo',
    type: 'string',
  },
  {
    id: 'space-1',
    name: 'space',
    type: 'space',
  },
  {
    id: 'space-2',
    name: 'space',
    type: 'space',
  },
  {
    id: 'cleanWaterValue',
    name: 'Clean Water (ppm)',
    type: 'number',
    disabled: true,
  },
  {
    id: 'gab-1',
    name: 'gab',
    type: 'gab',
  },
  {
    id: 'firstCheckIntended',
    name: '1st Check intended (ppm)',
    type: 'number',
    disabled: true,
  },
  {
    id: 'firstCheckValue',
    name: '1st Check measured (ppm)',
    type: 'number',
    disabled: true,
  },
  {
    id: 'secondCheckIntended',
    name: '2nd Check intended (ppm)',
    type: 'number',
    disabled: true,
  },
  {
    id: 'secondCheckValue',
    name: '2nd Check measured (ppm)',
    type: 'number',
    disabled: true,
  },
  {
    id: 'space-3',
    name: 'space',
    type: 'space',
  },
  {
    id: 'vessel',
    name: 'Vessel Name',
    type: 'string',
    disabled: false,
  },
  {
    id: 'imo',
    name: 'IMO Number',
    type: 'number',
    disabled: false,
  },
  {
    id: 'batchCalCheck',
    name: 'Batch No. of Check Fluid',
    type: 'string',
    disabled: false,
  },
  {
    id: 'placeOfCalibration',
    name: 'Place of Calibration',
    type: 'string',
    disabled: false,
  },
  {
    id: 'separatorMarker',
    name: 'Separator Manufacturer',
    type: 'string',
    disabled: false,
  },
  {
    id: 'separatorInfo',
    name: 'Separator Type (SN)',
    type: 'string',
    disabled: false,
  },
  {
    id: 'deckmaInfo',
    name: 'Comment',
    type: 'string',
    disabled: false,
  },

  {
    id: 'produktionsdatum',
    name: 'Date of production',
    type: 'month',
  },
  {
    id: 'email',
    name: 'E-Mail',
    type: 'text',
  },
];
